import { ajaxRequest, getActionAjax } from "@comact/crc";
import _ from "lodash";
import { IPaginatedResults } from "../common";
import {
    ICreateSalesforceCaseMetadata,
    ICreateSalesforceCaseRequest,
    ICreateSalesforceCaseResponse,
    IFile,
    ISalesforceCase,
    ISalesforceCaseContactFilterMetadata,
    ISalesforceCaseContactOption,
    ISalesforceURLSearchParams
} from "./model";
import { actions } from "./slices";

export const getCases = getActionAjax((siteId: string, urlSearchParams: ISalesforceURLSearchParams) => (dispatch) => (
    ajaxRequest({
        serverLessResolve: () => import("./mocks").then((m) => m.getCases()),
        method: "POST",
        data: {
            status: urlSearchParams.status,
            machine: urlSearchParams.machine,
            contactId: urlSearchParams.contactId,
            sortDescending: true,
        },
        url: `/api/salesforce/cases?${new URLSearchParams({ siteId, pageSize: "10", pageNumber: urlSearchParams.pageNumber || "1" }).toString()}`,
        showAjaxLoading: true,
        onSuccess: (pagedResults: IPaginatedResults<ISalesforceCase>) => {
            const items = pagedResults.items.map((c) => ({ ...c, activities: { records: c.activities?.records ?? [] } }));
            pagedResults.items = items;
            dispatch(actions.setResults(pagedResults));
        },
    })
));

export const getCaseStatuses = getActionAjax((siteId: string) => (dispatch) => ajaxRequest({
    url: `/api/salesforce/cases/status?siteId=${encodeURIComponent(siteId)}`,
    onSuccess: (statuses: Record<string, string>) => {
        dispatch(actions.setStatuses(statuses));
    },
}));

export const getCaseContacts = getActionAjax((siteId: string) => (dispatch) => ajaxRequest({
    url: `/api/salesforce/cases/contacts?siteId=${encodeURIComponent(siteId)}`,
    onSuccess: (metadata: ISalesforceCaseContactFilterMetadata) => {
        dispatch(actions.setContactFilterMetadata(metadata));
    },
    onError: () => {
        dispatch(actions.setContactFilterMetadata({ contacts: [], defaultContactId: null }));
    },
}));

export const getCaseMachines = getActionAjax((siteId: string) => (dispatch) => ajaxRequest({
    url: `/api/salesforce/cases/machines?siteId=${encodeURIComponent(siteId)}`,
    onSuccess: (machines: string[]) => {
        dispatch(actions.setMachines(machines));
    },
}));

export const getCreateCaseMetadata = getActionAjax((siteId: string) => () => ajaxRequest({
    method: "GET",
    url: `/api/salesforce/cases/create/metadata?siteId=${encodeURIComponent(siteId)}`,
    showAjaxLoading: true,
    onSuccess: (metadata: ICreateSalesforceCaseMetadata) => metadata,
}));

export const getCreateCaseContacts = getActionAjax((siteId: string) => () => ajaxRequest({
    method: "GET",
    url: `/api/salesforce/cases/create/contacts?siteId=${encodeURIComponent(siteId)}`,
    onSuccess: (contacts: ISalesforceCaseContactOption[]) => contacts,
}));

export const createCase = getActionAjax((siteId: string, request: ICreateSalesforceCaseRequest, files: IFile[]) => () => {
    const formData = new FormData();
    if (files.length > 0) {
        request.description = `***Documents Attached***\r\n\r\n${request.description}`;
    }
    formData.append("requestJson", JSON.stringify(request));
    _.forEach(files, ({ file }) => formData.append("files", file, file.name));

    return ajaxRequest({
        method: "POST",
        data: formData,
        contentType: null,
        url: `/api/salesforce/cases/create/by-site?siteId=${encodeURIComponent(siteId)}`,
        showAjaxLoading: true,
        showAjaxLoadingProgress: !_.isEmpty(files),
        onSuccess: (response: ICreateSalesforceCaseResponse) => response,
    });
});
